import api from "api";

const PATH = "/ReporteErro";

const POST_REPORT_ERRO = async (reporteErro) => {
  try {
    // Cria um objeto FormData para enviar como multipart/form-data
    const formData = new FormData();
    formData.append("nomeUsuario", reporteErro.nomeUsuario); // Adiciona o nome do usuário
    formData.append("emailUsuario", reporteErro.emailUsuario); // Adiciona o email do usuário
    formData.append("descricaoErro", reporteErro.descricaoErro); // Adiciona a descrição do erro

    // Adiciona cada arquivo ao FormData
    if (reporteErro.anexos && reporteErro.anexos.length > 0) {
      for (const anexo of reporteErro.anexos) {
        formData.append("anexos", anexo); // 'anexos' é o nome do campo esperado na API
      }
    }

    // Faz a requisição POST com o FormData
    const { data } = await api.post(`${PATH}/reporte-erro`, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Define o tipo de conteúdo como multipart/form-data
      },
    });

    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export { POST_REPORT_ERRO };
